import { Component, OnInit, ViewChild } from '@angular/core';
import { AccountService } from 'src/app/services/account.service';
import { StorageService } from 'src/app/services/storage.service';

// Connect Wallet


import { ToastrService } from "ngx-toastr";
import {
  watchAccount,
  watchNetwork,
} from "@wagmi/core";

import { environment } from "src/environments/environment";

import {
  bscTestnet,
  holesky,
} from "@wagmi/core/chains";

import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @ViewChild('uiWallet') uiWallet;

  ethereum: any;
  connector: any;
  walletChainId: any;
  account: any = {};
  walletAccount: any = {};
  public web3Modal: any;
  
  constructor(private accountService: AccountService, private storageService: StorageService, private toastr: ToastrService) { }

  async ngOnInit() {
    this.accountService.walletObserve.subscribe((response) => {
      if (response.status) {
        this.connectWalletButton();
        const data = {
          status: false,
        };
        this.accountService.openWallet(data);
      }
    });
    this.wagmiConfig();
    this.setAccountProcess();

  }

  public wagmiConfig(){
    // wallet connect initialization
   const metadata = {
      name: 'Real World',
      description: 'Real World - Market',
      url: environment.WEB_SITE_URL,
      icons: ['https://avatars.githubusercontent.com/u/37784886']
    }
    const chains = [holesky, bscTestnet]
    const projectId = environment.projectId;
    
    const wagmiConfig = defaultWagmiConfig({ chains, projectId, metadata })

  this.web3Modal = createWeb3Modal({ wagmiConfig, projectId, chains, themeVariables: {'--w3m-accent': '#5c24ad','--w3m-border-radius-master':'0', '--w3m-z-index': 10000,'--w3m-font-family':'Source Code Pro' }, themeMode:'light' })
    watchNetwork(async (network) => {
      
      if (network.chain != undefined) {
        
          setTimeout(() => {
            this.setAccountProcess();
          }, 1000);
      }
    })
    watchAccount((connection) => {
      
      if(connection.isConnected){
          setTimeout(() => {
            this.setAccountProcess();
          }, 500);
      }
      if(connection.isDisconnected){
         this.setAccount('','','')
      }
      })
    
  }
  /**
   * Connects wallet button
   */
  public connectWalletButton(){
    this.web3Modal?.open();
  }

/**
 * Sets account process
 */
setAccountProcess(){
  let wagmi: any = localStorage.getItem("wagmi.store");
    wagmi = JSON.parse(wagmi);
    
    let wagmiData: any = localStorage.getItem('wagmi.store')
    wagmiData = JSON.parse(wagmiData)

    let parseWagmi: any = {}
    parseWagmi.address = wagmiData.state.data.account
    parseWagmi.network = 'holesky'
    parseWagmi.chainId = wagmiData.state.data.chain.id

    this.account = this.storageService.getItem('account') === null ? { address: "", network: "", chainId: "", provider: "" } : JSON.parse(this.storageService.getItem('account'));
    
    this.setAccount(parseWagmi.address, parseWagmi.chainId, this.account.provider);
}

  public async setAccount(address, chainId, provider) {
    this.account.address = address;
    this.account.chainId = chainId;
    this.account.network = await this.setNetwork(chainId);
    this.account.provider = provider;

    this.accountService.setAccount(this.account);
    this.account = Object.assign(this.account);
    this.storageService.setItem('account', JSON.stringify(this.account));

  }


  public setNetwork(chainId) {
    let network;

    switch (chainId) {
      case '0x1':
      case 1:
        network = "Mainnet";
        break;
      case '0x3':
      case 3:
        network = "Ropsten";
        break;
      case '0x4':
      case 4:
        network = "Rinkeby";
        break;
      case '0x5':
      case 5:
        network = "Goerli";
        break;
      case '0x38':
      case 56:
        network = 'BSC Mainnet';
        break;
      case '0x61':
      case 97:
        network = 'BSC Testnet';
        break;
      default:
        network = 'Unknown';
        break;
    }
    return network;
  }

}
